module.exports = __webpack_public_path__ + "media/images/top/cost/cost-image2-092415a8d229674073e5e2c6209dc50e.png";